import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { AdminMember } from "@/hooks/useAdminMembers";
import { cn } from "@/lib/utils";
import { initialen } from "./planungAnzeige";
import { AVATAR, AVATAR_ICH } from "./planungGestaltung";

interface Props {
  person: AdminMember | undefined;
  ich?: boolean;
  className?: string;
}

/** Bild oder Initialen der Person, mit Namen als Tooltip. */
export function PersonAvatar({ person, ich = false, className }: Props) {
  if (!person) return null;
  return (
    <Avatar className={cn("h-6 w-6", className)} title={person.displayName}>
      {person.avatar_url && <AvatarImage src={person.avatar_url} alt={person.displayName} />}
      <AvatarFallback className={cn("text-[10px] font-bold", ich ? AVATAR_ICH : AVATAR)}>
        {initialen(person.first_name, person.last_name, person.displayName)}
      </AvatarFallback>
    </Avatar>
  );
}
